import type { LocationSelectParentOptionItemData } from "../location-select-parent.type";

import { formatPathFromAncestors } from "@/entities/ancestor";

export const getLocationSelectParentOptionItem = (
  location: LocationSelectParentOptionItemData
) => {
  const { id, ancestors } = location;
  return {
    value: id,
    label: formatPathFromAncestors(ancestors, {
      shouldTruncate: false,
      includeTypes: ["location"],
    }),
    truncatedLabel: formatPathFromAncestors(ancestors, {
      shouldTruncate: true,
      includeTypes: ["location"],
    }),
  };
};
